import React from 'react';

class Iframe extends React.Component {
  render() {
    return null;
  }
}

export default Iframe;
